export default {
      id: "graph-madelaine-usage",
      viewBox: "0 0 138 205",
      url: __webpack_public_path__ + "svg/sprite.svg#graph-madelaine",
      toString: function () {
        return this.url;
      }
    }